import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { SettingValueModel } from 'src/app/models/api/setting-value.model';

@Injectable({
    providedIn: 'root'
})
export class CachedSettingsApiClient {

    private API_ENDPOINT = environment.apiUrl + "/settings";
    private forOrganisationGuid: string = "";
    private cache!: Observable<SettingValueModel[]> | null;

    constructor(private httpClient: HttpClient) { }
    /**
     * Grab organisation WORKFLOW settings (for now)
     * @param organisationGuid 
     * @returns 
     */
    getWorkflowSettings(organisationGuid: string) {
        if (this.forOrganisationGuid === organisationGuid) {
            return this.getCache(organisationGuid);
        } else {
            return this.getNonCache(organisationGuid);
        }
    }
    refreshCache() {
        this.cache = this.getNonCache(this.forOrganisationGuid).pipe(
            map(data => data
            ),
            shareReplay(1)
        );
    }
    private getCache(organisationGuid: string) {
        if (!this.cache) {
            this.cache = this.getNonCache(organisationGuid).pipe(
                map(data => data
                ),
                shareReplay(1)
            );
        }
        return this.cache;
    }
    private getNonCache(organisationGuid: string) {
        this.forOrganisationGuid = organisationGuid;
        return this.httpClient.get<SettingValueModel[]>(this.API_ENDPOINT + "/organisation/" + organisationGuid + "/workflows");
    }
}